import { FETCH_TEMPLATES_SUCCEEDED } from '../actions/ActionTypes';
import { TemplateSchema } from '../constants/TemplateSchema';
function hydrateTemplates(templates) {
  return templates.map(template => {
    const hydratedProps = TemplateSchema[template.path];
    return Object.assign({}, template, hydratedProps);
  });
}
const templates = (state = [], action) => {
  switch (action.type) {
    case FETCH_TEMPLATES_SUCCEEDED:
      return hydrateTemplates(action.payload);
    default:
      return state;
  }
};
export default templates;